import { render, staticRenderFns } from "./ContractorBuildingDetail.vue?vue&type=template&id=ecffbc20&scoped=true&"
import script from "./ContractorBuildingDetail.vue?vue&type=script&lang=js&"
export * from "./ContractorBuildingDetail.vue?vue&type=script&lang=js&"
import style0 from "./ContractorBuildingDetail.vue?vue&type=style&index=0&id=ecffbc20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecffbc20",
  null
  
)

export default component.exports